import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import animation from '../../images/jm-animation.gif';
import './KycForm.css';

function KycForm2({ pancard }) {
  const [myPanCard, setMyPanCard] = useState(pancard);
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [pancardError, setPancardError] = useState('');
  const [loadingshow, setLoadingshow] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [sessionId, setSessionId] = useState('');

  const CAMSURL = 'https://ekyc.camsonline.com/Home/Home';
  const CLIENTURL = 'https://jmmfapi.jmfinancialmf.com/GetCAMSDecrypted';
  // const CLIENTURL = 'http://localhost:5218/GetCAMSDecrypted';

  useEffect(() => {
    // Generate a unique session ID when the component mounts
    setSessionId(uuidv4());
  }, []);

  const handlePancardChange = (e) => {
    setMyPanCard(e.target.value.toUpperCase());
    setPancardError('');
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    setPhoneError('');
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError('');
  };

  const fetchVKycData = async (pan, email, phone) => {
    const raw = '';
    const requestOptions = {
      method: 'POST',
      body: raw,
      redirect: 'follow',
    };

    const url = `https://jmmfapi.jmfinancialmf.com/GetCAMSEncrypted?PANNumber=${pan}&emailid=${encodeURIComponent(email)}&mobile=${phone}&Session_Id=${sessionId}`;

    try {
      const response = await fetch(url, requestOptions);
      const result = await response.text();
      // alert(result)
      console.log(result, 'result');
      return result;

    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);


    //  alert(sessionId);
    // alert(myPanCard)
    // alert(email)
    // alert(phone)


    if (!myPanCard) {
      setPancardError('Please enter your PAN card number.');
      return;
    }

    if (!myPanCard.match(/[A-Z]{5}[0-9]{4}[A-Z]{1}/)) {
      setPancardError('Please enter a valid PAN card number.');
      return;
    }

    if (!phone) {
      setPhoneError('Please enter your phone number.');
      return;
    }

    if (!isValidPhoneNumber(phone)) {
      setPhoneError('Please enter a valid phone number.');
      return;
    }

    if (!email) {
      setEmailError('Please enter your email address.');
      return;
    }

    if (!isValidEmail(email)) {
      setEmailError('Please enter a valid email address.');
      return;
    }

    setLoadingshow(true);
    
    const vKycData = await fetchVKycData(myPanCard, email, phone);
    console.log(vKycData, 'vKycData');

    setTimeout(() => {
      setLoadingshow(false)
    }, 10000);

    if (!vKycData) {
      alert('Failed to fetch vKycData. Please try again.');
      return;
    }

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = CAMSURL;
    form.enctype = 'application/x-www-form-urlencoded';

    const hiddenInputs = [
      { name: 'url', value: CLIENTURL },
      { name: 'ekyctype', value: 'I' },
      { name: 'plkyc_type', value: 'INVESTOR' },
      { name: 'kyc_data', value: vKycData },
      { name: 'sess_id', value: sessionId },
    ];

    hiddenInputs.forEach(({ name, value }) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    setMyPanCard('');
    setEmail('');
    setPhone('');
  };

  const isValidPhoneNumber = (phoneNumber) => {
    return /^[6-9]{1}[0-9]{9}$/.test(phoneNumber);
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: 500, marginBottom: 10 }}>
          <div
            style={{
              backgroundColor: '#FFFFFF',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
              borderRadius: 8,
              padding: 20,
              zIndex: 0,
              position: "relative",
            }}
          >
            {loadingshow && (
              <div
                className="textcentervertex"
                style={{
                  position: 'absolute',
                  bottom: '35%',
                  left: '40%',
                  zIndex: 1,
                }}
              >
                <img src={animation} alt="Loading" />
                <div className="model_popup">Please Wait...</div>
              </div>
            )}
            <form onSubmit={handleSubmit} className={loadingshow ? 'blur' : ''}>
              <div style={{ marginBottom: 20 }}>
                <input
                  style={{
                    width: '100%',
                    padding: 10,
                    boxSizing: 'border-box',
                    border: 'none',
                    borderBottom: `2px solid ${isSubmitted && pancardError ? 'red' : '#CCCCCC'
                      }`,
                    borderRadius: 0,
                    outline: 'none',
                    transition: 'border-color 0.3s',
                  }}
                  type="text"
                  placeholder="Enter your PAN"
                  onChange={handlePancardChange}
                  maxLength={10}
                  value={myPanCard}
                />
                {isSubmitted && pancardError && (
                  <div style={{ color: 'red', fontSize: 12 }}>
                    {pancardError}
                  </div>
                )}
              </div>
              <div style={{ marginBottom: 20 }}>
                <input
                  style={{
                    width: '100%',
                    padding: 10,
                    boxSizing: 'border-box',
                    border: 'none',
                    borderBottom: `2px solid ${isSubmitted && phoneError ? 'red' : '#CCCCCC'
                      }`,
                    borderRadius: 0,
                    outline: 'none',
                    transition: 'border-color 0.3s',
                  }}
                  type="text"
                  placeholder="Enter your Phone Number"
                  onChange={handlePhoneChange}
                  maxLength={10}
                  value={phone}
                />
                {isSubmitted && phoneError && (
                  <div style={{ color: 'red', fontSize: 12 }}>{phoneError}</div>
                )}
              </div>
              <div style={{ marginBottom: 20 }}>
                <input
                  style={{
                    width: '100%',
                    padding: 10,
                    boxSizing: 'border-box',
                    border: 'none',
                    borderBottom: `2px solid ${isSubmitted && emailError ? 'red' : '#CCCCCC'
                      }`,
                    borderRadius: 0,
                    outline: 'none',
                    transition: 'border-color 0.3s',
                  }}
                  type="text"
                  placeholder="Enter your Email Address"
                  onChange={handleEmailChange}
                  value={email}
                />
                {isSubmitted && emailError && (
                  <div style={{ color: 'red', fontSize: 12 }}>{emailError}</div>
                )}
              </div>
              <div>
                <button
                  type="submit"
                  style={{
                    width: '100%',
                    backgroundColor: '#013c66',
                    color: 'white',
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: 4,
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KycForm2;



